if (!customElements.get('collection-page')) {
  class CollectionPage extends HTMLElement {
    constructor() {
      super();

      this.filterForm = this.querySelector('.js-filter-form');

      this.collectionQtyInfo = this.querySelector('.js-collection-info');

      this.sortToggle = this.querySelector('.js-sortby');
      this.sortByInputs = this.querySelectorAll('.js-filter-sortby');
      this.defaultSortByInput = this.querySelector('.js-filter-sortby.is-default');
      this.sortByLabel = this.querySelector('.js-sortby-label');

      this.filterList = this.querySelectorAll('.js-filter' , '.collection__size-options');
      this.filterInputs = this.querySelectorAll(
        '.js-filter-input, .js-filter-price-max, .js-filter-price-min' , '.js-size-filter-input'
      );
      this.collectionToggles = this.querySelectorAll('.js-filter-toggle, .js-filters-toggle');
      this.showMoreBtns = this.querySelectorAll('.js-filter-showMore');

      this.currentQtyText = this.querySelector('.js-collection-currentQty');
      this.totalQtyText = this.querySelector('.js-collection-totalQty');

      this.loadPreviousBtn = this.querySelector('.js-loadPrevious-btn');

      this.collectionGrid = this.querySelector('.js-collection-grid');
      this.collectionList = this.querySelector('.js-list-view');
      this.loadMoreContainer = this.querySelector('.js-loadmore-container');
      this.loadMoreBtn = this.querySelector('.js-loadMore-btn');
      this.processBar = this.querySelector('.js-collection-process');

      this.priceInput = this.querySelectorAll('.js-price-range');
      this.priceValueMin = this.querySelector('.js-filter-price-min');
      this.priceValueMax = this.querySelector('.js-filter-price-max');
      this.priceLabelMin = this.querySelector('.js-price-label-min');
      this.priceLabelMax = this.querySelector('.js-price-label-max');

      this.toggleFilterBtn = this.querySelector('.js-drawer-toggle');
      this.filterDrawerOpenBtn = this.querySelector('.js-drawer-open');

      this.countActiveFilters = this.querySelectorAll('.js-count-active-filter');
      this.filterDrawer = this.querySelector('.js-filter-drawer');
      this.filterClose = this.querySelector('.js-filter-close');
      this.filterSubmit = this.querySelector('.js-filter-submit');
      this.filterOverlay = this.querySelector('.js-filter-overlay');

      this.filterSearch = this.querySelector('.js-filter-search');
      this.clearInputBtn = this.querySelector('.js-clear-input');
      this.productTypesItems = this.querySelectorAll('.js-product-type');

      this.filterData = [];
      this.searchParamsInitial = window.location.search.slice(1);
      this.searchParamsPrev = window.location.search.slice(1);
      this.productPerPage = Number(this.loadMoreBtn?.dataset.perPage);
      this.maxProduct = Number(this.loadMoreBtn?.dataset.maxProduct);
      this.currentProductQty = Number(this.loadMoreBtn?.dataset.perPage);
      this.maxPage = Number(this.loadMoreBtn?.dataset.maxPage);
      this.currentPage = Number(this.loadMoreBtn?.dataset.currentPage || 1);
      this.previousPages = this.currentPage;

      this.disableInfinite = this.dataset.disableInfinite;


      this.bindEvents();
    }

    bindEvents() {
      this.onSubmitHandler();
      this.setSearchUrlListeners();
      this.clearFilter();
      this.callUpdateMedia();
      this.updatedSelected();
      this.toggleFilter();
      this.stickyToggleFilterOnMobile();
      this.showMoreFilters();

      if (!this.disableInfinite){
        this.triggerLoadMore();
      }

      this.updateRangePriceEvent();
      this.searchProductType();
      this.filterDrawerEvents();
      this.updateSortbyType();
      this.updateFilteredLabel();
      this.autoOpenFilter();
      this.showClearButton();
      this.clearInputText();
      this.removeFilterTags();
      this.setupCategoriesCarousel();
      this.onCategoriesClick();
      this.setupSizeFilterAjax();
    }

    onSubmitHandler() {
      if (!this.filterForm) return;
      const BREAKPOINT = 1024;

      // Trigger form on desktop
      const debouncedOnSubmit = debounce(async (event) => {
        this.checkSameFilterSwatch(event);

        const searchParams = this.createSearchParams(this.filterForm);

        if (window.innerWidth > BREAKPOINT) {
          await this.renderPage(searchParams, event);

          // render second page after filter
          this.loadSecondPageWhenScrolling();
        }
      }, 500);

      this.filterForm.addEventListener('input', debouncedOnSubmit.bind(this));

      // Trigger form on mobile
      this.filterSubmit.addEventListener('click', (event) => {
        if (window.innerWidth <= BREAKPOINT) {
          event.preventDefault();

          const searchParams = this.createSearchParams(this.filterForm);

          this.renderPage(searchParams, event);
          this.loadMoreHtml(true);
          this.toggleFilterDrawer();
        }
      });
    }

    checkSameFilterSwatch(event) {
      const dataFilter = event.target.dataset.filter,
        isCollapsed = event.target.dataset.collapsed === 'true',
        isChecked = event.target?.checked;

      if (!dataFilter || !isCollapsed) return;

      const sameFilters = this.querySelectorAll(`.js-filter-input[data-filter="${dataFilter}"]`);

      if (!sameFilters) return;

      sameFilters.forEach((filter) => {
        if (isChecked && !filter.checked) filter.checked = true;
        if (!isChecked) filter.checked = false;
      });
    }

    setSearchUrlListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this.renderPage(searchParams, null, false);
      };

      window.addEventListener('popstate', onHistoryChange);
    }

    async renderPage(searchParams, event, updateURLHash = true) {
      if (searchParams == this.searchParamsPrev) return;

      this.searchParamsPrev = this.clearSearchParams(searchParams);

      this.toggleClearFilterButton();

      // Handle fetch depend on filter params
      const url = `${this.dataset.urlHandle}?${searchParams}`;

      const filterDataUrl = (element) => element.url === url;

      this.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl, event)
        : await this.renderSectionFromFetch(url, event);

      if (updateURLHash) this.updateURLHash(searchParams);

      this.collectionGrid.scrollIntoView({ behavior: 'smooth' });
      this.collectionList?.scrollIntoView({ behavior: 'smooth' });
    }

    async renderSectionFromFetch(url, event) {
      this.collectionGrid.classList.add('is-loading');
      this.collectionList?.classList.add('is-loading');

      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/plain'
        }
      })
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;

          this.filterData = [...this.filterData, { html, url }];

          this.renderProductGrid(html);
          this.renderQuantityInfo(html);
          this.renderFilterInputs(html);
          this.renderCountActiveFilter(html);
          this.callUpdateMedia();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.collectionGrid.classList.remove('is-loading');
          this.collectionList?.classList.remove('is-loading');
        });
    }

    renderSectionFromCache(filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).html;

      this.collectionGrid.classList.add('is-loading');
      this.collectionList?.classList.add('is-loading');

      this.renderProductGrid(html);
      this.renderQuantityInfo(html);
      this.renderFilterInputs(html);
      this.renderCountActiveFilter(html);
      this.callUpdateMedia();

      this.collectionGrid.classList.remove('is-loading');
      this.collectionList?.classList.remove('is-loading');
    }

    getDOMParser(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    renderProductGrid(html) {
      const DOMParser = this.getDOMParser(html);

      if (DOMParser.querySelector('.js-collection-grid')) {
        // Update collection grid
        this.querySelector('.js-collection-grid').innerHTML =
          DOMParser.querySelector('.js-collection-grid').innerHTML;

        // Update collection remove tags
        this.querySelector('.js-remove-filter-tags').innerHTML =
          DOMParser.querySelector('.js-remove-filter-tags').innerHTML;

        // Reset function identify new elements
        this.clearFilter();
        this.removeFilterTags();

        // Update lazy load images, refresh stamped
        if (window.updateLazyLoad) window.updateLazyLoad();
        if (window.StampedFn) window.StampedFn.reloadUGC();
      }
      if (DOMParser.querySelector('.js-list-view')) {
        // Update collection list
        this.querySelector('.js-list-view').innerHTML =
          DOMParser.querySelector('.js-list-view').innerHTML;

        // Update collection remove tags
        this.querySelector('.js-remove-filter-tags').innerHTML =
          DOMParser.querySelector('.js-remove-filter-tags').innerHTML;

        // Reset function identify new elements
        this.clearFilter();
        this.removeFilterTags();

        // Update lazy load images, refresh stamped
        if (window.updateLazyLoad) window.updateLazyLoad();
        if (window.StampedFn) window.StampedFn.reloadUGC();
      }
    }

    renderQuantityInfo(html) {
      const DOMParser = this.getDOMParser(html);
      const ajaxLoadMoreContainer = DOMParser.querySelector('.js-loadmore-container');

      if (ajaxLoadMoreContainer) {
        this.loadMoreContainer.classList.remove('hidden');

        this.maxProduct = Number(
          ajaxLoadMoreContainer.querySelector('.js-collection-totalQty').textContent
        );
        this.currentProductQty = Number(
          ajaxLoadMoreContainer.querySelector('.js-collection-currentQty').textContent
        );
        this.maxPage = Number(
          ajaxLoadMoreContainer.querySelector('.js-loadMore-btn').dataset.maxPage
        );
        this.currentPage = Number(
          ajaxLoadMoreContainer.querySelector('.js-loadMore-btn').dataset.currentPage
        );

        this.updateLoadMoreContainer();
        this.updateQuantityTexts();
      }

      if (!ajaxLoadMoreContainer || this.currentProductQty >= this.maxProduct)
        this.loadMoreContainer.classList.add('hidden');
    }

    renderFilterInputs(html) {
      const DOMParser = this.getDOMParser(html);

      this.filterInputs.forEach((filterInput) => {
        // Check / UnCheck input based on current search params
        const urlSearchParams = new URLSearchParams(this.searchParamsPrev);

        const isChecked = urlSearchParams.has(filterInput.name, filterInput.value);

        filterInput.checked = isChecked;

        // Update content text
        const filterInputId = filterInput.id;
        const filterText = filterInput.parentElement.querySelector(
          `.js-filter-text[data-id="${filterInputId}"]`
        );
        const newFilterText = DOMParser.querySelector(
          `.js-filter-text[data-id="${filterInputId}"]`
        );

        if (filterText && newFilterText) filterText.innerHTML = newFilterText.innerHTML;

        this.updateSizeFilterActiveStates();
      });
    }

    updateSizeFilterActiveStates() {
      const sizeInputs = this.querySelectorAll('.js-size-filter-input');
      const urlSearchParams = new URLSearchParams(this.searchParamsPrev);

      sizeInputs.forEach(input => {
        const isChecked = urlSearchParams.has(input.name, input.value);
        const label = input.closest('label');

        if (label) {
          if (isChecked) {
            input.checked = true;
            label.classList.add('active');
          } else {
            input.checked = false;
            label.classList.remove('active');
          }
        }

      });
    }

    renderCountActiveFilter(html) {
      const DOMParser = this.getDOMParser(html);

      this.countActiveFilters.forEach((countFilter) => {
        countFilter.innerHTML = DOMParser.querySelector('.js-count-active-filter').innerHTML;
      });
    }

    updateURLHash(searchParams) {
      const paramsObj = new URLSearchParams(searchParams);

      paramsObj.delete('section_id');
      const stateParams = paramsObj.toString();

      history.pushState(
        {},
        '',
        `${this.dataset.urlHandle}${stateParams && '?'.concat(stateParams)}`
      );
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);

      searchParams.append('section_id', this.dataset.id);

      if (
        searchParams.get('filter.v.price.gte') == '' ||
        searchParams.get('filter.v.price.gte') == 0
      )
        searchParams.delete('filter.v.price.gte');
      if (
        searchParams.get('filter.v.price.lte') == '' ||
        searchParams.get('filter.v.price.lte') == this.priceValueMax.max
      )
        searchParams.delete('filter.v.price.lte');

      if (this.dataset.currentType && this.dataset.currentType != '')
        searchParams.append('q', this.dataset.currentType);

      const searchString = searchParams.toString();

      return searchString;
    }

    clearSearchParams(searchParams) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('section_id');

      return newSearchParams.toString();
    }

    /***********************
     * FILTER ELEMENTS
     ***********************/
    toggleClearFilterButton() {
      const filterClearDesktop = this.querySelector('.js-filter-clear-desktop');

      let defaultSearchParams = `sort_by=${this.defaultSortByInput.value}`;

      if (this.dataset.currentType) defaultSearchParams += `&q=${this.dataset.currentType}`;

      filterClearDesktop.classList[
        this.searchParamsPrev == '' || this.searchParamsPrev == defaultSearchParams
          ? 'add'
          : 'remove'
      ]('hidden');
    }

    clearFilter() {
      const filterClearBtns = this.querySelectorAll('.js-filter-clear');
      const filterClearDesktop = this.querySelector('.js-filter-clear-desktop');

      if (!filterClearBtns || !filterClearDesktop) return;

      [...filterClearBtns, filterClearDesktop].forEach((clearBtn) => {
        clearBtn.addEventListener('click', (e) => {
          e.preventDefault();

          // ajax collection grid
          this.renderPage('');

          // clear sortByInput
          if (this.defaultSortByInput) this.defaultSortByInput.checked = true;

          // clear filter input
          this.filterInputs.forEach((input) => {
            if (input.type == 'checkbox') input.checked = false;
          });

          this.resetPriceInput();

          // toggle drawer filter
          const hideOnClick = clearBtn.dataset.hideOnClick;
          hideOnClick ? clearBtn.classList.add('hidden') : this.toggleFilterDrawer('remove');

          this.updateFilterListQty();
        });
      });
    }

    removeFilterTags() {
      const removeFilterTags = this.querySelectorAll('.js-remove-filter-tag');

      removeFilterTags.forEach((removeFilter) => {
        removeFilter.addEventListener('click', async () => {
          // Get filter url
          let currentSearchURL = this.searchParamsPrev || window.location.search;

          // Clear ? in first character
          currentSearchURL.charAt(0) == '?'
            ? (currentSearchURL = currentSearchURL.substring(0, 1))
            : '';

          // Remove selected filter tag
          const currentSearchURLParams = new URLSearchParams(currentSearchURL);
          const removedKey = removeFilter.dataset.paramName;
          const removeValue = removeFilter.dataset.value;

          if (!removedKey || !removeValue) return;

          currentSearchURLParams.delete(removedKey, removeValue);
          currentSearchURLParams.delete('page');

          // Call ajax to render newest content
          await this.renderPage(currentSearchURLParams.toString());

          this.updateFilterListQty();
        });
      });
    }

    updateFilterListQty() {
      this.filterList.forEach((filterList) => {
        this.showNumberSelected(filterList);
      });
    }

    filterDrawerEvents() {
      if (!this.toggleFilterBtn || !this.filterDrawer || !this.filterDrawerOpenBtn) return;

      this.filterDrawerOpenBtn.addEventListener('click', () => {
        this.toggleFilterDrawer();
      });

      [this.toggleFilterBtn, this.filterOverlay, this.filterClose].forEach((element) => {
        element.addEventListener('click', () => {
          this.toggleFilterDrawer();

          this.toggleFilterBtn.classList[
            this.toggleFilterBtn.classList.contains('is-hide') ? 'remove' : 'add'
          ]('is-hide');
        });
      });
    }

    toggleFilterDrawer(actionType = 'toggle') {
      if (this.filterDrawer && this.filterOverlay) {
        this.filterDrawer.classList[actionType]('is-open');
        this.filterOverlay.classList[actionType]('is-open');
        this.classList[actionType]('is-zindex');
      }
    }

    updateLoadMoreContainer() {
      const processWidth = (this.currentProductQty / this.maxProduct) * 100;

      if (this.loadMoreContainer) {
        this.currentQtyText.textContent = this.currentProductQty;
        this.totalQtyText.textContent = this.maxProduct;
        this.processBar.style.setProperty('--width', `${processWidth}%`);

        if (this.maxPage > this.currentPage) this.loadMoreContainer.classList.remove('hidden');
      }
    }

    updateQuantityTexts() {
      // Update collection count
      if (this.collectionQtyInfo) {
        if (this.maxProduct <= 1)
          this.collectionQtyInfo.innerHTML = `${this.maxProduct} ${window.productQuantity.one}`;
        else
          this.collectionQtyInfo.innerHTML = `${this.maxProduct} ${window.productQuantity.others}`;
      }

      // Update
    }

    callUpdateMedia() {
      let swatchFilter = [];

      /* Default based on filter swatch name */
      const urlSearchParams = new URLSearchParams(this.searchParamsPrev);
      const filterSwatchSettings = this.dataset.swatches?.toLowerCase();

      if (filterSwatchSettings && urlSearchParams) {
        urlSearchParams.forEach((value, key) => {
          if (key.startsWith('filter.v.option')) {
            const optionName = key.replace('filter.v.option.', '');
            if (filterSwatchSettings.includes(optionName)) {
              swatchFilter.push(value);
            }
          }
        });
      }

      /* Filter by typing result on search page (priority filter swatch -> typing result) */
      if (this.dataset.currentType) {
        const typingSearch = this.dataset.currentType.split(' ');

        typingSearch.forEach((text) => swatchFilter.unshift(text));
      }

      /* Dispatch update media */
      requirejs(['pubsub'], () => {
        publishEvent(PUB_SUB_EVENTS.filterSwatch, {
          source: 'collection',
          data: { swatchList: swatchFilter }
        });
      })
    }

    stickyToggleFilterOnMobile() {
      if (!this.toggleFilterBtn) return;

      window.addEventListener('scroll', () => {
        if (window.scrollY >= 800 && window.innerWidth <= 560) {
          if (!this.filterDrawer.classList.contains('is-open')) {
            this.toggleFilterBtn.classList.remove('is-hide');
            this.toggleFilterBtn.classList.add('is-fixed');
          }
        } else this.toggleFilterBtn.classList.remove('is-fixed');
      });
    }

    /***********************
     * LOAD MORE MODULE
     ***********************/
    async triggerLoadMore() {
      // remove natural event cache of browser
      if ('scrollRestoration' in history) window.history.scrollRestoration = 'manual';

      // Assign events
      await this.loadSecondPageWhenScrolling();
      this.cachePreviousPosition();
      this.renderPrevPositionCollection();

      // Click load more button manually on page 2,3,4,...
      this.loadMoreBtn?.addEventListener('click', () => {
        if (this.loadMoreContainer) this.loadMoreHtml(true);
      });

      this.loadPreviousBtn?.addEventListener('click', () => {
        this.loadMoreHtml(true, false);
      });
    }

    async loadSecondPageWhenScrolling() {
      const productPerPage = this.productPerPage || 20;

      // GET anchor point to start load second page // 8 is two row before end current collection page.
      const anchorStartLoadMore =
        this.querySelectorAll(`.js-product-card`)[productPerPage - 8] || this.loadMoreBtn;

      if (!anchorStartLoadMore) return;

      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(async (entry) => {
            if (entry.intersectionRatio > 0) {
              await this.loadMoreHtml(true);
              observer.disconnect();
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.01
        }
      );

      observer.observe(anchorStartLoadMore);
    }

    renderPrevPositionCollection() {
      const currentHref = window.location.href;
      const cachedProductId = sessionStorage.getItem(currentHref);
      if (!cachedProductId) return;

      const cachedProductCard = this.querySelector(`.js-product-card[data-id="${cachedProductId}"`);

      if (!cachedProductCard) return;

      cachedProductCard.scrollIntoView();
    }

    cachePreviousPosition() {
      const productCardLinks = this.querySelectorAll('.js-product-card a','.product-card-horizontal a');
      if (!productCardLinks) return;

      productCardLinks.forEach((productCardLink) => {
        productCardLink.addEventListener('click', () => {
          sessionStorage.setItem(
            `${window.location.href}`,
            productCardLink.closest('.js-product-card')?.dataset.id
          );
        });
      });
    }

    async loadMoreHtml(cacheHistory = true, loadNextPage = true) {
      const { previousPage, nextPage, pageURL } = this.getLoadMoreUrl(loadNextPage);

      if (loadNextPage && nextPage > this.maxPage) {
        return this.loadMoreContainer?.classList?.add('hidden');
      }

      this.collectionGrid.classList.add('is-loading');
      this.collectionList?.classList.add('is-loading');

      loadNextPage
        ? this.loadMoreBtn?.classList?.add('is-loading')
        : this.loadPreviousBtn?.classList?.add('is-loading');

      try {
        const response = await fetch(pageURL);
        const html = await response.text();
        const dom = new DOMParser().parseFromString(html, 'text/html');

        const collectionGridHtml = dom.querySelector('.js-collection-grid');
        const collectionListHtml = dom.querySelector('.js-list-view');

        const isEmpty = collectionGridHtml?.classList.contains('is-empty') || collectionListHtml?.classList.contains('is-empty');
        if (isEmpty) cacheHistory = false;

        // GRID
        if (this.collectionGrid && collectionGridHtml && !collectionGridHtml.classList.contains('is-empty')) {
          this.collectionGrid.insertAdjacentHTML(
            loadNextPage ? 'beforeend' : 'afterbegin',
            collectionGridHtml.innerHTML
          );
        }

        // LIST
        if (this.collectionList && collectionListHtml && !collectionListHtml.classList.contains('is-empty')) {
          this.collectionList.insertAdjacentHTML(
            loadNextPage ? 'beforeend' : 'afterbegin',
            collectionListHtml.innerHTML
          );
        }

        if (loadNextPage) {
          this.currentPage++;
          nextPage == this.maxPage
            ? (this.currentProductQty = this.maxProduct)
            : (this.currentProductQty += this.productPerPage);
        } else {
          this.previousPages--;
          this.currentProductQty += this.productPerPage;
          if (this.previousPages == 1) this.loadPreviousBtn.classList.add('hidden');
        }

        this.updateLoadMoreContainer();
        this.updateQuantityTexts();
        this.callUpdateMedia();

        if (cacheHistory) history.replaceState({}, '', `${pageURL}`);
        this.cachePreviousPosition();
      } catch (error) {
        console.error('Load More Error:', error);
      } finally {
        if (typeof updateLazyLoad === 'function') updateLazyLoad();
        if (typeof StampedFn !== 'undefined') StampedFn.reloadUGC?.();

        loadNextPage
          ? this.loadMoreBtn?.classList?.remove('is-loading')
          : this.loadPreviousBtn?.classList?.remove('is-loading');

        this.collectionGrid.classList.remove('is-loading');
        this.collectionList?.classList.remove('is-loading');

        if (loadNextPage && nextPage >= this.maxPage) {
          this.loadMoreContainer.classList.add('hidden');
        }
      }
    }


    getLoadMoreUrl(loadNextPage = true) {
      const searchParams = new URLSearchParams(this.searchParamsPrev);

      const currentPage = loadNextPage ? this.currentPage + 1 : this.previousPages - 1;

      searchParams.get('page') != ''
        ? searchParams.set('page', currentPage)
        : searchParams.append('page', currentPage);

      const pageURL = `${this.dataset.url}?${searchParams.toString()}`;

      return {
        previousPage: this.previousPages - 1,
        nextPage: this.currentPage + 1,
        pageURL
      };
    }

    /*********************************
     * SEARCH PRODUCT TYPE MODULE
     *********************************/
    searchProductType() {
      if (!this.filterSearch) return;

      this.filterSearch.addEventListener('input', () => {
        debounce(() => {
          const searchText = this.filterSearch.value.toUpperCase();
          let showNumber = 0;

          this.productTypesItems.forEach((productType) => {
            if (searchText != '') {
              const dataFilter = productType.dataset.filter.toUpperCase();

              if (dataFilter.indexOf(searchText) > -1) {
                if (showNumber < 6) {
                  productType.classList.remove('hidden');
                  showNumber++;
                }
              } else productType.classList.add('hidden');
            } else {
              if (showNumber < 6) {
                productType.classList.remove('hidden');
                showNumber++;
              } else productType.classList.add('hidden');
            }
          });
        }, 100).apply(this);
      });
    }

    showClearButton() {
      this.filterSearch.addEventListener('input', () => {
        if (this.filterSearch.value) {
          this.clearInputBtn.classList.remove('is-hidden');
          this.clearInputBtn.previousElementSibling.classList.add('is-hidden');
        } else {
          this.clearInputBtn.classList.add('is-hidden');
          this.clearInputBtn.previousElementSibling.classList.remove('is-hidden');
        }
      });
    }

    clearInputText() {
      this.clearInputBtn.addEventListener('click', () => {
        this.filterSearch.value = '';
        this.clearInputBtn.classList.add('is-hidden');
        this.clearInputBtn.previousElementSibling.classList.remove('is-hidden');
        this.productTypesItems.forEach((productType) => {
          productType.classList.remove('hidden');
        });
      });
    }

    /***********************
     * FILTER SIDEBAR MODULE
     ***********************/
    updateSortbyType() {
      if (!this.sortByLabel) return;

      this.sortByInputs.forEach((input) => {
        input.addEventListener('input', () => {
          if (input.dataset.name) this.sortByLabel.innerHTML = input.dataset.name;
        });
      });
    }

    toggleFilter() {
      if (!this.collectionToggles) return;

      this.collectionToggles.forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.parentElement.classList.toggle('is-open');
        });
      });
    }

    showMoreFilters() {
      this.showMoreBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const filterList = btn.previousElementSibling;
          let isShow = true;

          btn.classList.contains('is-show') ? (isShow = false) : (isShow = true);

          if (isShow) {
            filterList.querySelectorAll('li.hidden').forEach((liTag) => {
              if (!liTag.classList.contains('js-filter-collapsed'))
                liTag.classList.remove('hidden');
            });
            btn.classList.add('is-show');
          } else {
            filterList.querySelectorAll('li').forEach((liTag, index) => {
              if (index > 6) liTag.classList.add('hidden');
            });
            btn.classList.remove('is-show');
          }
          const filterSearch = btn.parentElement.querySelector('.js-filter-search');

          if (filterSearch) filterSearch.value = '';
        });
      });
    }

    updateFilteredLabel() {
      if (!this.filterList) return;

      this.filterList.forEach((filter) => {
        filter.addEventListener('change', (event) => {
          const isInputEvent = event.target.classList.contains('js-filter-input');
          if (!isInputEvent) return;

          this.showNumberSelected(filter);
        });
      });
    }

    updatedSelected() {
      this.filterList.forEach((filter, index) => {
        // Update selected label
        const filterSelection = filter.querySelector('.js-filter-selection'),
          collapsedFilters = filter.querySelectorAll('.js-collapsed:checked'),
          filterQtyLabels = filter.querySelectorAll('.js-filter-qty');

        if (filterSelection && collapsedFilters && collapsedFilters.length > 0) {
          const activeValues = Number(filterSelection.dataset.activeValues);
          let selectedFiltersText = '';

          collapsedFilters.forEach((filter, index) => {
            if (!filter.classList.contains('js-collapsed')) {
              selectedFiltersText += `${filter.value}${
                collapsedFilters.length > 1 && index != collapsedFilters.length - 1 ? ',' : ''
              }`;
            }
          });

          if (typeof activeValues == 'number' && activeValues > 0) {
            filterSelection.innerHTML = `${selectedFiltersText}`;

            filterQtyLabels.forEach((filterQtyLabel) => {
              filterQtyLabel.textContent = activeValues > 0 ? activeValues : '';
            });
          }
        }

        // Update show more label
        const showMoreBtn = filter.querySelector('.js-showMore-count');
        if (showMoreBtn && collapsedFilters) {
          const currentShowMore = Number(showMoreBtn.textContent);
          showMoreBtn.innerHTML = currentShowMore - collapsedFilters.length;
        }
      });
    }

    showNumberSelected(filter) {
      let countSelected = 0;
      const selectedFilters = filter.querySelectorAll('.js-filter-input:checked');
      let selectedFiltersText = '';

      selectedFilters.forEach((filter, index) => {
        if (!filter.classList.contains('js-collapsed')) {
          countSelected++;

          selectedFiltersText += `${filter.value}${
            selectedFilters.length > 1 && index != selectedFilters.length - 1 ? ', ' : ''
          }`;
        }
      });

      if (selectedFilters) {
        const selectedText = filter.querySelector('.js-filter-selection');
        const filterQtyLabel = filter.querySelector('.js-filter-qty');

        if (filterQtyLabel) {
          filterQtyLabel.textContent = countSelected > 0 ? countSelected : '';

          const matchedFilterCategoryQty = this.querySelector(
            `.js-filter-qty[data-filter="category-${filterQtyLabel?.dataset?.filter}"]`
          );

          if (matchedFilterCategoryQty) {
            matchedFilterCategoryQty.textContent = `(${countSelected})`;
            matchedFilterCategoryQty.style.display = countSelected > 0 ? 'inline-block' : 'none';
            matchedFilterCategoryQty.parentElement.classList[countSelected > 0 ? 'add' : 'remove'](
              'is-active'
            );
          }
        }

        if (selectedText) {
          countSelected > 0
            ? (selectedText.innerHTML = `${selectedFiltersText}`)
            : (selectedText.innerHTML = selectedText.dataset.all);
        }
      }
    }

    autoOpenFilter() {
      if (!this.filterList || window.matchMedia('(max-width: 960px)').matches) return;

      this.filterList.forEach((filter, index) => {
        if (index <= 1) filter.classList.add('is-open');
      });
    }

    /***********************
     * PRICE RANGE MODULE
     ***********************/
    updateRangePriceEvent() {
      this.priceInput.forEach((input) => {
        input?.addEventListener('input', () => {
          const { min, max } = this.getPriceRange();

          this.priceValueMin.value = min;
          this.priceValueMax.value = max;

          const left = (min * 100) / input.max,
            right = 100 - (max * 100) / input.max;

          input.parentElement.style.setProperty('--left', `${left}%`);
          input.parentElement.style.setProperty('--right', `${right}%`);

          if (this.priceLabelMin && this.priceLabelMax) {
            this.priceLabelMin.textContent = min;
            this.priceLabelMax.textContent = max;
          }
        });
      });

      [this.priceValueMin, this.priceValueMax].forEach((input) => {
        input?.addEventListener('input', () => {
          let priceRange = this.querySelector('.js-price-inputs'),
            minValue = this.priceValueMin.value,
            maxValue = this.priceValueMax.value;

          if (!minValue) minValue = 0;
          if (!maxValue) maxValue = this.priceValueMax.max;

          let left = (minValue * 100) / input.max,
            right = 100 - (maxValue * 100) / input.max;

          left < 0 ? (left = 0) : null;
          right > 100 ? (right = 100) : null;
          right < 0 ? (right = 100) : null;

          priceRange.style.setProperty('--left', `${left}%`);
          priceRange.style.setProperty('--right', `${right}%`);

          this.priceInput[0].value = minValue;
          this.priceInput[1].value = maxValue;

          if (this.priceLabelMin && this.priceLabelMax) {
            this.priceLabelMin.textContent = minValue;
            this.priceLabelMax.textContent = maxValue;
          }
        });
      });
    }

    resetPriceInput() {
      [this.priceLabelMin, this.priceLabelMax].forEach((label) => {
        if (label) label.innerHTML = label.dataset.value;
      });

      this.priceValueMin.value = this.priceValueMin.min;
      this.priceValueMax.value = this.priceValueMax.max;

      this.priceInput.forEach((input, index) => {
        index == 0 ? (input.value = '0') : (input.value = `${input.max}`);
      });

      const priceInputs = this.querySelector('.js-price-inputs');

      priceInputs.style.setProperty('--left', `0%`);
      priceInputs.style.setProperty('--right', `0%`);
    }

    getPriceRange() {
      const priceArr = [];

      this.priceInput.forEach((input) => {
        priceArr.push(input.value);
      });

      priceArr.sort((a, b) => a - b);

      return {
        min: priceArr[0] || 0,
        max: priceArr[1]
      };
    }

    /***************************************
     * COLLECTION FILTER CATEGORIES
     ***************************************/
    setupCategoriesCarousel() {
      requirejs(['swiper'], (Swiper) => {
        this.categoriesCarousel = new Swiper(`.js-categories-carousel-${this.dataset.id}`, {
          grabCursor: false,
          lazy: true,
          resistanceRatio: 0.4,
          speed: 300,
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 4,
          navigation: {
            nextEl: `.js-swiper-next-${this.dataset.id}`,
            prevEl: `.js-swiper-prev-${this.dataset.id}`
          }
        });
      })
    }

    onCategoriesClick() {
      const categories = this.querySelectorAll('.js-filter-category');

      categories.forEach((category) => {
        category.addEventListener('click', () => {
          this.toggleFilterDrawer();

          const categoryIndex = category.dataset.index;
          const matchedFilerTab = this.querySelector(`.js-filter[data-index='${categoryIndex}']`);

          this.filterList.forEach((filterItem) => {
            filterItem.classList.remove('is-open');
          });

          if (matchedFilerTab) {
            matchedFilerTab.classList.add('is-open');
            matchedFilerTab.focus();
          }
        });
      });
    }

    setupSizeFilterAjax() {
      const sizeInputs = this.querySelectorAll('.js-size-filter-input');
      if (!sizeInputs.length) return;

      sizeInputs.forEach(input => {
        input.addEventListener('change', (event) => {
          const allSizeInputs = Array.from(this.querySelectorAll('.js-size-filter-input'));
          const checkedInputs = allSizeInputs.filter(i => i.checked);

          // get current URL params
          const currentParams = new URLSearchParams(window.location.search);

          //first remove all size params
          allSizeInputs.forEach(i => {
            currentParams.delete(i.name, i.value);
          });

          // then add checked size params
          checkedInputs.forEach(i => {
            currentParams.append(i.name, i.value);
          });

          //remove empty params
          for (const [key, value] of currentParams.entries()) {
            if (value === '') {
              currentParams.delete(key);
            }
          }

          // update active class for labels
          allSizeInputs.forEach(i => {
            const label = i.closest('label');
            if (label) {
              if (i.checked) {
                label.classList.add('active');
              } else {
                label.classList.remove('active');
              }
            }
          });

          this.renderPage(currentParams.toString(), event);
        });
      });
    }
  }

  customElements.define('collection-page', CollectionPage);
}
